const LOGGED_IN = ['landing-page', 'request-type', 'customer-data', 'review-submit', 'complete'];
const LOGGED_OUT = ['landing-page','request-type', 'customer-data', 'company-info', 'review-submit', 'complete'];


let signedIn = false;

const signedOutPages = 5;
const signedInPages = 4;

// request-type form logic
var correctionInfo;
var correctionInfoTextbox;

var requestTypeForm;
var requestType;

//customer-data form logic
var customerForm;
var loggedInCustomer;

// company-info form logic
var companyForm;
var requestDate;

// review logic
const reviewIds = [
    'request-type-display',
    'full-name-display',
    'email-display',
    'state-display',
    'address-display-1',
    'address-display-2',
    'address-display-3',
    'address-display-4',
    'business-type-display'
]
var reviewElements = {};

// complete logic
let completeIds = ["reference-number", "confirm-request-type-display", "request-date-display", "reference-number-display"]

// navigation logic
let pages = {};
let nextPageButton;
let backPageButton;
let pageWrapper;

var page = 0;
var pageIds = LOGGED_OUT;

// display logic
let titleArea;
let buttonSection;
let progressBarNumber;

// User Selections
var selectedOption;
var requestType;
var customerData;
var companyData;

const date = new Date();
const referenceNumber = 'SFE-' + date.getFullYear() + String(date.getMonth() + 1).padStart(2, '0') + String(date.getDate()).padStart(2, '0') + '-' +
    String(date.getMinutes()).padStart(2, '0') + String(date.getSeconds()).padStart(2, '0') + String(date.getMilliseconds()).padStart(2, '0').substring(0, 2);


var loggedInUserData = null;
var emailsSent = [];

window.addEventListener('load', async function() {
    getSentEmailAddresses();

    // hide the button until it's clickable
    let startButton = document.getElementById('start-button');
    if(startButton) startButton.style.display = 'block';


    // navigation logic
    nextPageButton = document.getElementById('next-page');
    backPageButton = document.getElementById('back-page');
    nextPageButton.addEventListener('click', handleNextPage);
    backPageButton.addEventListener('click', handleBackPage);
    pageWrapper = document.getElementById('page-wrapper');

    titleArea = document.getElementById('title-area');
    buttonSection = document.getElementById('button-section');
    progressBarNumber = document.getElementById('progress-bar-section');

    // customer-data form logic
    customerForm = document.querySelector('#customer-form');
    let customer_data = new FormData(customerForm);
    customerData = Object.fromEntries(customer_data.entries());

//     company-info form logic
    companyForm = document.querySelector('#company-form');
    let company_data = new FormData(companyForm);
    companyData = Object.fromEntries(company_data.entries());

    // privacy-type form logic
    correctionDetails = document.getElementById("correction-details");
    correctionType = document.getElementById("correction-type");
    correctionInfoTextbox = document.getElementById("correction-info");
    requestTypeForm = document.querySelector('#request-type-form');

    handleSignedIn();

    for (let i = 0; i < pageIds.length; i++) {
        pages[i] = document.getElementById(pageIds[i]);
    }

    let inputs = pages[1].getElementsByTagName("input");

    for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener('click', function() {
            selectedOption = this.value;
            showDetails();
        });
    }
})


function handleSignedIn(){

    if(typeof window.loggedInUser === 'undefined') return;

    signedIn = true;

    loggedInUserData = window.loggedInUser;
    pageIds = LOGGED_IN;

    let items = progressBarNumber.getElementsByTagName('li');

    const labels = ['Request Type', 'Your Information', 'Review & Submit', 'Complete']
    for (let i = 0; i < items.length; i++) {
        items[i].children[0].innerText = i + 1;
        items[i].children[1].innerText = labels[i];
        if(i > labels.length - 1){
            items[i].style.display = 'none';
        }
    }
    document.getElementById("account-sign-in").style.display = "none";

    customerData.full_name = loggedInUserData.name.length > 0 ? loggedInUserData.name : loggedInUserData.firstName + loggedInUserData.lastName;
    customerData.email = loggedInUserData.email;
    if(Object.keys(loggedInUserData.address).length > 0){
        customerData.phone = loggedInUserData.address.phone;
        customerData.state_of_residence = loggedInUserData.address.provinceCode;
        customerData['zip-code'] = loggedInUserData.address.zip;
        companyData.business_city = loggedInUserData.address.city;
        companyData.business_state = loggedInUserData.address.provinceCode;
        companyData.business_street = loggedInUserData.address.address1;
        companyData.business_street_2 = loggedInUserData.address.address2;
        companyData.business_zip = loggedInUserData.address.zip;

        // hide address in review page if the user doesn't have an address in Shopify
        let hasContent = Object.keys(loggedInUserData.address).filter(key => loggedInUserData.address[key] !== null && loggedInUserData.address[key] !== '');
        if(hasContent.length < 1){
            document.getElementById('address-display').style.display = 'none';
        }
    }
    populateSignedInInputs();
}

function handleNextProgress() {
    let pages = signedIn ? signedInPages : signedOutPages;
    let items = progressBarNumber.getElementsByTagName('li');
    let bar = progressBarNumber.getElementsByClassName('forward')[0];
    bar.style.width = (100 / pages) * page + '%';

    for (let i = 0; i < items.length; i++) {
        if(page - 1 >= i) {
            items[i].classList.add('step-reached');
        } else {
            items[i].classList.remove('step-reached');
        }
    }

    // if complete:
    if(page === pages) {
        bar.style.backgroundImage = 'linear-gradient(105deg, #00ad83 25%, #02d59e 25%, #02d59e 50%, #00ad83 50%, #00ad83 75%, #02d59e 75%, #02d59e 100%)';
        progressBarNumber.classList.add('progress-complete');
    }
}

function showDetails() {
    if (['Correct inaccurate personal information', 'Other privacy request'].includes(selectedOption)) {
        correctionDetails.style.display = 'block';
        correctionTypeText = selectedOption === 'Correct inaccurate personal information' ? '*Correct information' : '*Other Request';
        correctionType.innerText = correctionTypeText;
        correctionInfoTextbox.required = true;
    } else {
        correctionDetails.style.display = 'none';
        correctionInfoTextbox.required = false;
    }
}

function continueWithoutSignin() {
    buttonSection.style.display = 'flex';
    titleArea.style.display = 'block';
    pages[page].style.display = 'none';
    page++;
    pages[page].style.display = 'block';
    window.scrollTo({top:0});
    handleNextProgress();
}

function startPrivacyRequest() {
    buttonSection.style.display = 'flex';
    titleArea.style.display = 'block';
    pages[page].style.display = 'none';
    page++;
    pages[page].style.display = 'block';
    window.scrollTo({top:0});
    handleNextProgress();
}

function handleNextPage() {

    let success = false;
    if(!signedIn){
        switch (page) {
            case 0:
                break;
            case 1:
                if(requestTypeForm.checkValidity()){
                    let data = new FormData(requestTypeForm);
                    requestType = Object.fromEntries(data.entries());
                    pages[page].style.display = 'none';
                    page++;
                    pages[page].style.display = 'block';
                    success = true;
                }
                else requestTypeForm.classList.add('validated')
                break;
            case 2:
                let emailEl = document.getElementById('email');
                emailEl.setCustomValidity('');
                if(customerForm.checkValidity()){
                    let data = new FormData(customerForm);
                    customerData = Object.fromEntries(data.entries());

                    pages[page].style.display = 'none';
                    page++;
                    pages[page].style.display = 'block';
                    success = true;
                }
                else{
                    customerForm.classList.add('validated')
                }
                break;
            case 3:
                if(companyForm.checkValidity()){
                    let data = new FormData(companyForm);
                    companyData = Object.fromEntries(data.entries());
                    populateResults(reviewIds);
                    nextPageButton.innerText = 'Submit Request';
                    pages[page].style.display = 'none';
                    page++;
                    pages[page].style.display = 'block';
                    success = true;
                }
                else{
                    companyForm.classList.add('validated')
                }
                break;
            case 4:


                populateResults(completeIds);
                sendEmails();

                // for next page
                backPageButton.style.display = 'none';
                nextPageButton.innerText = 'Return Home';
                pageWrapper.classList.add('complete-page');

                pages[page].style.display = 'none';
                page++;
                pages[page].style.display = 'block';
                success = true;
                break;
            case 5:
                window.location.href = '/';
                break;
        }
    }
    else{
        switch (page) {
            case 0:
                break;
            case 1:
                if(requestTypeForm.checkValidity()){
                    let data = new FormData(requestTypeForm);
                    requestType = Object.fromEntries(data.entries());
                    pages[page].style.display = 'none';
                    page++;
                    pages[page].style.display = 'block';
                    success = true;
                }
                else requestTypeForm.classList.add('validated')
                break;
            case 2:
                let emailEl = document.getElementById('email');
                emailEl.setCustomValidity('');
                if(customerForm.checkValidity()){
                    let data = new FormData(customerForm);
                    customerData = Object.fromEntries(data.entries());

                    pages[page].style.display = 'none';
                    page++;
                    pages[page].style.display = 'block';
                    success = true;
                    populateResults(reviewIds);
                    nextPageButton.innerText = 'Submit Request';
                }
                else{
                    customerForm.classList.add('validated')
                }
                break;

            case 3:
                populateResults(completeIds);
                sendEmails();

                // for next page
                backPageButton.style.display = 'none';
                nextPageButton.innerText = 'Return Home';
                pageWrapper.classList.add('complete-page');

                pages[page].style.display = 'none';
                page++;
                pages[page].style.display = 'block';
                success = true;
                break;
            case 4:
                window.location.href = '/';
                break;
        }
    }

    if(success) window.scrollTo({top:0});
    handleNextProgress();
}

function populateResults(reviewArray) {
    for (let i = 0; i < reviewArray.length; i++) {
        let data = document.getElementById(reviewArray[i]);
        if(!data) continue;
        switch (reviewArray[i]) {
            case 'request-type-display':
            case 'confirm-request-type-display':
                data.innerText = selectedOption;
                break;
            case 'full-name-display':
                data.innerText = customerData.full_name;
                break;
            case 'email-display':
                data.innerText = customerData.email;
                break;
            case 'state-display':
                data.innerText = customerData.state_of_residence;
                break;
            case 'address-display-1':
                data.innerText = companyData.business_name;
                break;
            case 'address-display-2':
                data.innerText = companyData.business_street;
                break;
            case 'address-display-3':
                data.innerText = companyData.business_street_2;
                break;
            case 'address-display-4':
                data.innerText = companyData.business_city + ' ' + companyData.business_state + ', ' + companyData.business_zip;
                break;
            case 'reference-number-display':
            case 'reference-number':
                data.innerText = referenceNumber;
                break;
            case 'request-date-display':
                let date = new Date();
                requestDate = new Intl.DateTimeFormat('en-US', {month: 'short',day: 'numeric',year: 'numeric', hour12: true, hour: 'numeric', minute: 'numeric', timeZoneName: 'short'}).format(date)
                data.innerText = new Intl.DateTimeFormat('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour12: true, hour: 'numeric', timeZoneName: 'short'}).format(date);
                break;
        }
    }
}
function populateSignedInInputs(){
    document.getElementById('full-name').value = customerData.full_name;
    document.getElementById('email').value = customerData.email;
    document.getElementById('phone').value = customerData.phone;
    document.getElementById('state-of-residence').value = customerData.state_of_residence;
    document.getElementById('zip_code').value = customerData['zip-code'];
    document.getElementById('business-city').value = companyData.business_city;
    document.getElementById('business-state').value = companyData.business_state;
    document.getElementById('business-street').value = companyData.business_street;
    document.getElementById('business-street-2').value = companyData.business_street_2;
    document.getElementById('business-zip').value = companyData.business_zip;
}

function handleBackPage() {
    switch (page) {
        case 1:
            buttonSection.style.display = 'none';
            titleArea.style.display = 'none';
            pages[page].style.display = 'none';
            page--;
            pages[page].style.display = 'block';
            break;
        case 2:
        case 3:
        case 4:
        case 5:
            nextPageButton.innerText = 'Continue';
            nextPageButton.style.display = 'block';
            pages[page].style.display = 'none';
            page--;
            pages[page].style.display = 'block';
            break;
        case 0:
            window.location.href = '/';
            break;
    }
    window.scrollTo({top:0});
    handleNextProgress();
}

function sendEmails(){

    fetch("https://flow-webhooks.k8s.eu.codecreationlabs.cloud/webhook/s3qrgeh0", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Api-Key": "4q7m5h012o2l0p6f187f727u020t3d1o2g2v7j442i3b4j235g003j6q1k314063"
        },
        body: JSON.stringify({...requestType, ...customerData, ...companyData, 'reference_number' : referenceNumber, 'signed_in': signedIn, 'request_date': requestDate})
    }).then(res => res.json()).then(data => {

        if(!emailsSent.includes(customerData.email.trim().toLowerCase())){
            sendConfirmationEmail();
        }

    }).catch(err => {
        console.error(err);
    });
}


function sendConfirmationEmail(){
    let confirmationData = {
        service_id: "service_77d32xg",
        template_id: "template_kg3vpmm",
        user_id: "zZoerwC7BhSmTjKxk",
        template_params: {
            'email': customerData.email,
            'reference_number' : referenceNumber
        }
    };

    fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        body: JSON.stringify(confirmationData),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((res) => {
        setSentEmailAddresses(customerData.email);
    })
    .catch(err => {
        console.error(err);
    })
}

function getSentEmailAddresses(){
    window.localStorage.getItem('emailsSent') ? emailsSent = JSON.parse(window.localStorage.getItem('emailsSent')) : emailsSent = [];
}
function setSentEmailAddresses(email){
    window.localStorage.setItem('emailsSent', JSON.stringify(emailsSent))
}
